export const SITE_URL = 'https://uinvert.com';
export const SITE_NAME = 'INVERT';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

export const DEFAULT_SEO = {
  title: 'INVERT — Restaurant TV Content & Restaurant TV Box for Venues',
  description:
    'Restaurant TV content made simple. Plug in the INVERT restaurant TV box, type what you want, and update every screen instantly — menus, specials, hiring, and more.',
  path: '/',
};
